import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AulasPage } from '@/app/aulas/AulasPage';

export const Route = createFileRoute('/_aberto/cursos/')({
  validateSearch: z.object({
    // `.catch`: URL editada à mão não derruba a página, só perde o filtro.
    tag: z.string().optional().catch(undefined),
    busca: z.string().optional().catch(undefined),
  }),
  component: function AulasRoute() {
    const filters = Route.useSearch();
    const navigate = Route.useNavigate();
    return <AulasPage filters={filters} onFiltersChange={(search) => navigate({ search, replace: true })} />;
  },
});
